import React, { useState } from 'react';
import { Wrapper, Content, Controls, Title, Info, Footer, OrganizationTag } from './card-organization.styles';
import { CardOrganizationProps } from './types';
import { Typography } from '@shared/ui/typography/typography';
import { STATUS_MAP } from '../../config/ui-constants';
import { AllInvestmentProducts, AllReceipt } from '@vtbhome/juicyfront/indexIcon';
import { Tag } from '@shared/ui/tag/tag';
import { COLORS } from '@shared/config/colors/colors';
import { wordByCount } from '@shared/lib/utils/word-by-count/word-by-count';
import { getOrganizationStatus } from '@shared/lib/utils/get-organization-status/get-organization-status';
import { organizationContacts } from '@entities/organization/libs/utils/organization-contacts/organization-contacts';

export const CardOrganization: React.FC<CardOrganizationProps> = ({ organization, children }) => {
    const statusData = STATUS_MAP[getOrganizationStatus(organization)];
    const [isShowControls, setIsShowControls] = useState(false);

    const handleMouseEnter = () => {
        setIsShowControls(true);
    };

    const handleMouseLeave = () => {
        setIsShowControls(false);
    };
    return (
        <Wrapper onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <Content>
                <Title>
                    <Typography size='subtitle1'>{organization.shortName}</Typography>
                    <Tag variant={statusData.variant}> {statusData.text}</Tag>
                </Title>
                <Info>
                    <Typography size='body2_short' color='neutral_50'>
                        Реквизиты: ИНН {organization.inn}, КПП {organization.kpp}
                    </Typography>
                    <Typography size='body2_short' color='neutral_50'>
                        {organizationContacts(organization)}
                    </Typography>
                </Info>
                <Footer>
                    <OrganizationTag>
                        <AllInvestmentProducts size='xxs' color={COLORS.neutral_50} />
                        <Typography size='body2_short' color='neutral_50'>
                            {wordByCount({
                                count: organization.countUsers,
                                words: ['сотрудник', 'сотрудника', 'сотрудников'],
                            })}
                        </Typography>
                    </OrganizationTag>
                    <OrganizationTag>
                        <AllReceipt size='xxs' color={COLORS.neutral_50} />
                        <Typography size='body2_short' color='neutral_50'>
                            {wordByCount({
                                count: organization.countProducts,
                                words: ['продукт', 'продукта', 'продуктов'],
                            })}
                        </Typography>
                    </OrganizationTag>
                </Footer>
            </Content>
            <Controls isShow={isShowControls}>{children}</Controls>
        </Wrapper>
    );
};
